import React, { useEffect, useState, useContext } from 'react';
import $ from 'jquery';
import './NavHeader.css';
import NotificationTable from '../NotificationTable';
import { w3cwebsocket as W3CWebSocket } from 'websocket';
import { checkConnection, UserContext, workDayURL } from '../../constant';

import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { notificationInsert } from '../../service/todo';
import { getNotification } from '../../service/WfhAPI';
import '../../components/NavHeader//NavHeader.css';
import { encryptStorage } from '../../constant';
import { getProfileImage } from '../../service/adminApi';
import { getProfileAndCoverImage } from '../../service/DirectorAPI';

function NavHeader() {
    const navigate = useNavigate();
    const [hideNavBar, sethideNavBar] = useState(true);

    let [LoginRole, setLoginRole] = React.useState('');
    let [empID, setempID] = React.useState('');
    let [notificationShow, setNotificationShow] = React.useState(false);
    let [notificationData, setNotificationData] = React.useState([]);
    const [recruitRole, setRecruitRole] = React.useState('');
    const [profile, setProfile] = React.useState('');

    const [adminDisable, setadminDisable] = useState(false);

    // let isAdmin = encryptStorage.getItem('groupid');
    // let isadd = isAdmin == 1 ? true : false;
    // setadminDisable(isadd);

    let linkview = window.location.pathname;
    encryptStorage.getItem('employeeId');
    let headNavHide = useLocation()?.state?.hideNav;

    React.useEffect(() => {
        // ;
        getLoginRole();
        sethideNavBar(headNavHide);
    }, []);

    const getLoginRole = async () => {
        let storage = encryptStorage.getItem('role');
        let empID = encryptStorage.getItem('employeeId');
        //let value = encryptStorage.encryptValue(empID);
        setempID(empID);
        setLoginRole(storage);

        let recruitRoles = encryptStorage.getItem('recruitRole');
        setRecruitRole(recruitRoles);
        let EmployeeData = {
            emp_id: encryptStorage.getItem('employeeId'),
        };
        let response = await getProfileAndCoverImage(EmployeeData);

        //let response = await getProfileImage({ id: encryptStorage.getItem('employeeId') });
        setProfile(response?.data?.ResponseData[0][0].profile_img_url);
    };

    const loaddata = async () => {
        let response = await getNotification({ empId: empID });
        setNotificationData(response.data.ResponseData);
        setNotificationShow(true);
    };

    const HeaderHrManger = () => {
        if (LoginRole === 'Hr Manager' || LoginRole === 'Hr') {
            return (
                <nav className="d-flex flex-wrap justify-content-center border-bottom fixed-top pt-2 bg-white">
                    <a href="/Overview" className="d-flex ps-2 align-items-center mb-2 me-md-auto text-dark text-decoration-none">
                        <img src="/Images/hivelogo.svg" alt="hive-logo" style={{ height: '32px' }} />
                    </a>
                    <ul className="nav nav-pills">
                        <li className="header-nav-item mx-3">
                            <a
                                className={
                                    linkview.includes('/Overview') || linkview.includes('/overview')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                href="/Overview"
                                aria-current="page"
                            >
                                Dashboard
                            </a>
                        </li>

                        <li class="header-nav-item mx-3 dropdown">
                            <a
                                href="#"
                                className={
                                    linkview.includes('/Recruitment') || linkview.includes('/Onboarding')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                id="navbarDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            // hidden={adminDisable}
                            >
                                Recruitment
                            </a>
                            <div class="header-dropdown-content header-dropdown-content-variation p-0">
                                <div class="d-flex">
                                    <div class="header-column-1 p-0 rounded-3">
                                        <a href="/Recruitment" class="ps-4 header-text-orange font-12 bold-text">
                                            <img src="/Images/Jobs Icon.svg" class="me-3" alt="" />
                                            Jobs
                                        </a>
                                        <a href="/Onboarding" class="ps-4 header-text-orange font-12 bold-text">
                                            <img src="/Images/Onboarding.svg" class="me-3" alt="" />
                                            Onboarding
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="header-nav-item mx-3">
                            <a
                                className={
                                    linkview.includes('/todo')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                // href={`https://workdaynp.avasoft.com/${encryptStorage.getItem('userId')}/myTODO`}
                                href={`${workDayURL}`} 
                            //className="header-nav-link semibold-text font-14 font-dark-blue pb-3"
                            >
                                To Do
                            </a>
                        </li>

                        <li className="header-nav-item mx-3">
                            <a
                                className={
                                    linkview.includes('/leavewfh') || linkview.includes('/leaveform') || linkview.includes('/wfhform')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                href="/leavewfh"
                            //className="header-nav-link semibold-text font-14 font-dark-blue pb-3"
                            >
                                Leave
                            </a>
                        </li>
                        <li className="header-nav-item mx-3 dropdown">
                            <a
                                href=""
                                className={
                                    linkview.includes('/performance') ||
                                        linkview.includes('/touchbase') ||
                                        linkview.includes('/TeamDirectory') ||
                                        linkview.includes('/moodgrid') ||
                                        linkview.includes('/HrOffboardingGrid') ||
                                        linkview.includes('/concerns') ||
                                        linkview.includes('/FeedbackGrid') ||
                                        linkview.includes('/profileupdate') ||
                                        linkview.includes('/goaltemplate') ||
                                        linkview.includes('/concernForm') ||
                                        linkview.includes('/performanceevaluation') ||
                                        linkview.includes('/appreciation')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                id="navbarDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Team Member
                            </a>
                            <div className="header-dropdown-content p-0">
                                <div className="row">
                                    <div className="header-column p-0">
                                        <a href="/performance" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/performance.svg" className="me-3" alt="" />
                                            Performance
                                        </a>
                                        <a href="/touchbase" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Touchbase.svg" className="me-3" alt="" />
                                            Touchbase
                                        </a>
                                        <a href="/TeamDirectory" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Team Directory.svg" className="me-3" alt="" />
                                            Team Directory
                                        </a>
                                        <a href="/MoodGrid" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Team Member Moods.svg" className="me-3" alt="" />
                                            Team members mood
                                        </a>
                                        <a
                                            onClick={() => {
                                                navigate('/goaltemplate', { state: { way: 'nav' } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Manage Goals.svg" className="me-3" alt="" />
                                            Manage Goals
                                        </a>
                                    </div>
                                    <div className="header-column p-0">
                                        <a href="/HrOffboardingGrid" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Offboarding.svg" className="me-3" alt="" />
                                            Offboarding
                                        </a>
                                        <a
                                            onClick={() => {
                                                navigate('/concerns', { state: { way: 0 } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Concern.svg" className="me-3" alt="" />
                                            Concern
                                        </a>
                                        <a href="/appreciation" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Appreciation.svg" className="me-3" alt="" />
                                            Appreciation
                                        </a>
                                        <a href={`/FeedbackGrid?EmpId=${empID}`} className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Feedback.svg" className="me-3" alt="" />
                                            Feedback
                                        </a>
                                        <a href="/profileupdate" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Profile Update.svg" className="me-3" alt="" />
                                            Profile Update
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="header-nav-item mx-3 dropdown">
                            <a
                                href="/HowdoI"
                                className={
                                    linkview.includes('/holidaylist') || linkview.includes('/faq') || linkview.includes('/policy')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                // className="header-nav-link dropdown-toggle semibold-text font-14 font-dark-blue pb-3"
                                id="navbarDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                How Do I?
                            </a>
                            <div className="header-dropdown-content p-0">
                                <div className="row">
                                    <div className="header-column p-0">
                                        <a
                                            onClick={() => {
                                                navigate(`/leaveform`, { state: { switchTab: 'leave', way: 'howDoI' } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Leave Request.svg" className="me-3" alt="" />
                                            Leave Request
                                        </a>
                                        <a
                                            onClick={() => {
                                                navigate(`/wfhform`, { state: { switchTab: 'wfh', way: 'howDoI' } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/WFH Request.svg" className="me-3" alt="" />
                                            WFH Request
                                        </a>
                                        <a
                                            onClick={() => {
                                                navigate('/concernForm', { state: { way: 'HowDoI' } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Raise a Concern.svg" className="me-3" alt="" />
                                            Raise a Concern
                                        </a>
                                        <a
                                            href="https://avacorp1.sharepoint.com/sites/AVAPortal?CID=436a98d3-f1b3-438c-ad2e-1ca28aa3a2c9&xsdata=MDV8MDF8fGVkMjJlNTliMWFlMDRhODc5YTY3MDhkYjIwOTFkOWI3fDcxNmY4M2MzN2FiZDQyYTE4NmQyZTAyMDdmNGFhOTgxfDB8MHw2MzgxMzk1ODI5OTgwOTIzOTF8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaVYybHVNeklpTENKQlRpSTZJazkwYUdWeUlpd2lWMVFpT2pFeGZRPT18MXxNVFkzT0RNMk1UUTVPRGc0TnpzeE5qYzRNell4TkRrNE9EZzNPekU1T2pRMk56RmpZbVpoTFRFMFkySXROREZsTWkwNVlUYzJMV0k0TkRBeFpqZzRaV0UzTkY4MFltSmpOelJoTWkweU56QTFMVFF3TW1FdFlXVTBNUzFqWkdGaU4yVXlaRGcwTVRSQWRXNXhMbWRpYkM1emNHRmpaWE09fGNkMjU4NTYwZDQzMjQwYjU5YTY3MDhkYjIwOTFkOWI3fDBlMjU2MjRjZmYwMzQ2ODJiMDRhYjQwZjFlMTM0MDYy&sdata=VjJTaGk0MnNwb2IzWDAzUUtpTDJYK1p1SjUvajhHUjBWYitnMWFNWHN4Zz0%3D&ovuser=716f83c3-7abd-42a1-86d2-e0207f4aa981%2CJayalakshmi.p%40avasoft.com&OR=Teams-HL&CT=1678362652106&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyNy8yMzAyMDUwMTQyMSIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D"
                                            target="_blank"
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Employee-gallery-icon.svg" className="me-3" alt="" />
                                            Employee Gallery
                                        </a>
                                    </div>
                                    <div className="header-column p-0">
                                        <a href="/holidaylist" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Holiday.svg" className="me-3" alt="" />
                                            Holiday List
                                        </a>
                                        <a href="/faq" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/FAQS.svg" className="me-3" alt="" />
                                            FAQ's
                                        </a>
                                        <a href="/policy" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/policy.svg" className="me-3" alt="" />
                                            Policy
                                        </a>
                                        <a href="/policyDirectory" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/policy.svg" className="me-3" alt="" />
                                            Policy Directory
                                        </a>
                                        <a href="/centcom" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="" className="me-3" alt="" />
                                            Centcom
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li className="header-nav-item mx-3">
                            <a
                                href="/admin/accountbranding"
                                className={
                                    linkview.includes('/admin')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                            >
                                Admin
                            </a>
                        </li>

                        <li className="dropdown mx-3">
                            <button
                                onClick={() => {
                                    loaddata();
                                }}
                                className="btn p-0"
                                type="button"
                                id="notification"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                            >
                                <img src="/Images/bell-header.svg" />
                                <span
                                    id="notificationDot"
                                    className="position-absolute top-0 start-100 translate-middle p-1  border border-light "
                                ></span>
                            </button>
                            <div
                                className="dropdown-menu notifaction-dropdown header-column-notification header-nav-item header-dropdown-content"
                                style={{
                                    position: 'absolute',
                                    inset: '0px auto auto 0px',
                                    margin: '0px',
                                    transform: 'translate(-285px, 30px)',
                                }}
                                data-popper-placement="bottom-end"
                            >
                                <span className="position-absolute top-1 start-100 translate-middle p-1  border border-light "></span>
                                <NotificationTable notification={notificationData} />
                            </div>
                        </li>

                        <li className="header-nav-item mx-3 dropdown">
                            <a className="d-block link-dark text-decoration-none">
                                <img
                                    src="/Images/logo-person-user-person-icon.jpg"
                                    alt="header-profile"
                                    width={32}
                                    height={32}
                                    className="rounded-circle"
                                />
                            </a>
                            <div class="header-dropdown-content p-0">
                                <div class="d-flex">
                                    <div class="header-column-1 p-0 rounded-3">
                                        <a
                                            href={`/profilecontainer?EmpId=${encryptStorage.getItem('employeeId')}&IsTeamMember=true`}
                                            class="ps-4 header-text-orange font-12 bold-text"
                                        >
                                            <img src="/Images/Jobs Icon.svg" class="me-3" alt="" />
                                            My Profile
                                        </a>
                                        <a href="/" class="ps-4 header-text-orange font-12 bold-text" onClick={() => handleLogout()}>
                                            <img src="/Images/Onboarding.svg" class="me-3" alt="" />
                                            Logout
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </nav>
            );
        }
    };

    const handleLogout = () => {
        try {
            encryptStorage.clear();

            window.location.href('/');
        } catch (error) { }
    };

    const HeaderEmployee = () => {
        if (LoginRole === 'Team Member')
            return (
                <nav className="d-flex  ps-2 flex-wrap justify-content-center border-bottom fixed-top pt-2 bg-white">
                    <a href="/Overview" className="d-flex align-items-center mb-2 me-md-auto text-dark text-decoration-none">
                        <img src="/Images/hivelogo.svg" alt="hive-logo" style={{ height: '32px' }} />
                    </a>
                    <ul className="nav nav-pills">
                        <li className="header-nav-item mx-3">
                            <a
                                href="/Overview"
                                className={
                                    linkview.includes('/Overview') || linkview.includes('/overview')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                aria-current="page"
                            >
                                Dashboard
                            </a>
                        </li>
                        {recruitRole == 'Panel Member' && LoginRole !== 'Hr Manager' ? ( 
                            <li class="header-nav-item mx-3 dropdown">
                                <a
                                    href="#"
                                    className={
                                        linkview.includes('/Recruitment') || linkview.includes('/Onboarding')
                                            ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                            : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                    }
                                    id="navbarDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Recruitment
                                </a>
                                <div class="header-dropdown-content header-dropdown-content-variation p-0">
                                    <div class="d-flex">
                                        <div class="header-column-1 p-0 rounded-3">
                                            <a href="/Recruitment" class="ps-4 header-text-orange font-12 bold-text">
                                                <img src="/Images/Jobs Icon.svg" class="me-3" alt="" />
                                                Jobs
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ) : null}

                        <li className="header-nav-item mx-3">
                            <a
                                // href={`https://workdaynp.avasoft.com/${encryptStorage.getItem('userId')}/myTODO`}
                                 href={`${workDayURL}`} 
                                //  href='#'
                                
                                className={
                                    linkview.includes('/todo')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                            >
                                To Do
                            </a>
                        </li>
                        <li className="header-nav-item mx-3">
                            <a
                                href="/leavewfh"
                                className={
                                    linkview.includes('/leavewfh') || linkview.includes('/leaveform') || linkview.includes('/wfhform')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                            >
                                Leave
                            </a>
                        </li>
                        <li className="header-nav-item mx-3 dropdown">
                            <a
                                href="/performance"
                                className={
                                    linkview.includes('/performance') ||
                                        linkview.includes('/touchbase') ||
                                        linkview.includes('performanceevaluation')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                //className="header-nav-link dropdown-toggle semibold-text font-14 font-dark-blue pb-3"
                                id="navbarDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                My Performance
                            </a>
                            <div className="header-dropdown-content p-0 custom-header-1">
                                <div className="row">
                                    <div className="header-column p-0">
                                        <a href="/performance" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/performance.svg" className="me-3" alt="" />
                                            Performance
                                        </a>
                                        <a href="/touchbase" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Touchbase.svg" className="me-3" alt="" />
                                            Touchbase
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="header-nav-item mx-3 dropdown">
                            <a
                                href=""
                                className={
                                    linkview.includes('/HolidayList') ||
                                        linkview.includes('/FAQ') ||
                                        linkview.includes('/policy') ||
                                        linkview.includes('/concernForm')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                // className="header-nav-link dropdown-toggle semibold-text font-14 font-dark-blue pb-3"
                                id="navbarDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                How Do I?
                            </a>
                            <div className="header-dropdown-content p-0">
                                <div className="row">
                                    <div className="header-column p-0">
                                        <a
                                            onClick={() => {
                                                navigate(`/leaveform`, { state: { switchTab: 'leave', way: 'howDoI' } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Leave Request.svg" className="me-3" alt="" />
                                            Leave Request
                                        </a>
                                        <a
                                            onClick={() => {
                                                navigate(`/wfhform`, { state: { switchTab: 'wfh', way: 'howDoI' } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/WFH Request.svg" className="me-3" alt="" />
                                            WFH Request
                                        </a>
                                        <a
                                            onClick={() => {
                                                navigate('/concerns', { state: { way: 0 } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Raise a Concern.svg" className="me-3" alt="" />
                                            Raise a Concern
                                        </a>
                                        <a
                                            href="https://avacorp1.sharepoint.com/sites/AVAPortal?CID=436a98d3-f1b3-438c-ad2e-1ca28aa3a2c9&xsdata=MDV8MDF8fGVkMjJlNTliMWFlMDRhODc5YTY3MDhkYjIwOTFkOWI3fDcxNmY4M2MzN2FiZDQyYTE4NmQyZTAyMDdmNGFhOTgxfDB8MHw2MzgxMzk1ODI5OTgwOTIzOTF8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaVYybHVNeklpTENKQlRpSTZJazkwYUdWeUlpd2lWMVFpT2pFeGZRPT18MXxNVFkzT0RNMk1UUTVPRGc0TnpzeE5qYzRNell4TkRrNE9EZzNPekU1T2pRMk56RmpZbVpoTFRFMFkySXROREZsTWkwNVlUYzJMV0k0TkRBeFpqZzRaV0UzTkY4MFltSmpOelJoTWkweU56QTFMVFF3TW1FdFlXVTBNUzFqWkdGaU4yVXlaRGcwTVRSQWRXNXhMbWRpYkM1emNHRmpaWE09fGNkMjU4NTYwZDQzMjQwYjU5YTY3MDhkYjIwOTFkOWI3fDBlMjU2MjRjZmYwMzQ2ODJiMDRhYjQwZjFlMTM0MDYy&sdata=VjJTaGk0MnNwb2IzWDAzUUtpTDJYK1p1SjUvajhHUjBWYitnMWFNWHN4Zz0%3D&ovuser=716f83c3-7abd-42a1-86d2-e0207f4aa981%2CJayalakshmi.p%40avasoft.com&OR=Teams-HL&CT=1678362652106&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyNy8yMzAyMDUwMTQyMSIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D"
                                            target="_blank"
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Employee-gallery-icon.svg" className="me-3" alt="" />
                                            Employee Gallery
                                        </a>
                                    </div>
                                    <div className="header-column p-0">
                                        <a href="/HolidayList" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Holiday.svg" className="me-3" alt="" />
                                            Holiday List
                                        </a>
                                        <a href="/FAQ" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/FAQS.svg" className="me-3" alt="" />
                                            FAQ's
                                        </a>
                                        <a href="/policy" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/policy.svg" className="me-3" alt="" />
                                            Policy
                                        </a>
                                        {/* <a href="/appreciation" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/policy.svg" className="me-3" alt="" />
                                            Appreciation
                                        </a> */}
                                        {encryptStorage.getItem("grc") ? (<a href="/policyDirectory" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/policy.svg" className="me-3" alt="" />
                                            Policy Directory
                                        </a>) : <></>}
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li className="dropdown mx-3">
                            <button
                                onClick={() => {
                                    loaddata();
                                }}
                                className="btn p-0"
                                type="button"
                                id="notification"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                            >
                                <img src="/Images/bell-header.svg" />
                                <span
                                    id="notificationDot"
                                    className="position-absolute top-0 start-100 translate-middle p-1  border border-light "
                                ></span>
                            </button>

                            <div
                                className="dropdown-menu notifaction-dropdown header-column-notification header-nav-item header-dropdown-content"
                                style={{
                                    position: 'absolute',
                                    inset: '0px auto auto 0px',
                                    margin: '0px',
                                    transform: 'translate(-285px, 30px)',
                                }}
                                data-popper-placement="bottom-end"
                            >
                                <span className="position-absolute top-1 start-100 translate-middle p-1  border border-light "></span>
                                <NotificationTable notification={notificationData} />
                            </div>
                        </li>

                        <li className="header-nav-item mx-3 dropdown">
                            <a href="#" className="d-block link-dark text-decoration-none">
                                <img
                                    src="/Images/logo-person-user-person-icon.jpg"
                                    alt="header-profile"
                                    width={32}
                                    height={32}
                                    className="rounded-circle"
                                />
                            </a>
                            <div class="header-dropdown-content p-0">
                                <div class="d-flex">
                                    <div class="header-column-1 p-0 rounded-3">
                                        <a
                                            href={`/profilecontainer?EmpId=${empID}&IsTeamMember=true`}
                                            class="ps-4 header-text-orange font-12 bold-text"
                                        >
                                            <img src="/Images/Jobs Icon.svg" class="me-3" alt="" />
                                            My Profile
                                        </a>
                                        <a href="/" class="ps-4 header-text-orange font-12 bold-text" onClick={() => handleLogout()}>
                                            <img src="/Images/Onboarding.svg" class="me-3" alt="" />
                                            Logout
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </nav>
            );
    };

    const HeaderManger = () => {
        if (LoginRole === 'Manager') {
            return (
                <nav className="d-flex ps-2 flex-wrap justify-content-center border-bottom fixed-top pt-2 bg-white">
                    <a href="/Overview" className="d-flex align-items-center mb-2 me-md-auto text-dark text-decoration-none">
                        <img src="/Images/hivelogo.svg" alt="hive-logo" style={{ height: '32px' }} />
                    </a>
                    <ul className="nav nav-pills">
                        <li className="header-nav-item mx-3">
                            <a
                                href="/Overview"
                                className={
                                    linkview.includes('/Overview') || linkview.includes('/overview')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                aria-current="page"
                            >
                                Dashboard
                            </a>
                        </li>
                        {recruitRole == 'Panel Member' && LoginRole !== 'Hr Manager' ? (
                            <li class="header-nav-item mx-3 dropdown">
                                <a
                                    href="#"
                                    className={
                                        linkview.includes('/Recruitment') || linkview.includes('/Onboarding')
                                            ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                            : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                    }
                                    id="navbarDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Recruitment
                                </a>
                                <div class="header-dropdown-content header-dropdown-content-variation p-0">
                                    <div class="d-flex">
                                        <div class="header-column-1 p-0 rounded-3">
                                            <a href="/Recruitment" class="ps-4 header-text-orange font-12 bold-text">
                                                <img src="/Images/Jobs Icon.svg" class="me-3" alt="" />
                                                Jobs
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        ) : null}
                        <li className="header-nav-item mx-3">
                            <a
                                className={
                                    linkview.includes('/todo')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                // href={`https://workdaynp.avasoft.com/${encryptStorage.getItem('userId')}/myTODO`}
                                 href={`${workDayURL}`} 
                            // className="header-nav-link semibold-text font-14 font-dark-blue pb-3"
                            >
                                To Do
                            </a>
                        </li>

                        <li className="header-nav-item mx-3">
                            <a
                                className={
                                    linkview.includes('/leavewfh') || linkview.includes('/leaveform') || linkview.includes('/wfhform')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                href="/leavewfh"
                            >
                                Leave
                            </a>
                        </li>
                        <li className="header-nav-item mx-3 dropdown">
                            <a
                                href="/performance"
                                className={
                                    linkview.includes('/performance') ||
                                        linkview.includes('/touchbase') ||
                                        linkview.includes('/TeamDirectory') ||
                                        linkview.includes('/moodgrid') ||
                                        linkview.includes('/HrOffboardingGrid') ||
                                        linkview.includes('/concerns') ||
                                        linkview.includes('/FeedbackGrid') ||
                                        linkview.includes('/profileupdate') ||
                                        linkview.includes('/goaltemplate') ||
                                        linkview.includes('/concernForm') ||
                                        linkview.includes('/performanceevaluation') ||
                                        linkview.includes('/appreciation')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                id="navbarDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                Team Member
                            </a>
                            <div className="header-dropdown-content p-0">
                                <div className="row">
                                    <div className="header-column p-0">
                                        <a href="/performance" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/performance.svg" className="me-3" alt="" />
                                            Performance
                                        </a>
                                        <a href="/touchbase" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Touchbase.svg" className="me-3" alt="" />
                                            Touchbase
                                        </a>
                                        <a href="/TeamDirectory" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Team Directory.svg" className="me-3" alt="" />
                                            Team Directory
                                        </a>
                                        <a
                                            onClick={() => {
                                                navigate('/goaltemplate', { state: { way: 'nav' } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Manage Goals.svg" className="me-3" alt="" />
                                            Manage Goals
                                        </a>
                                        <a href="/moodgrid" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Team Member Moods.svg" className="me-3" alt="" />
                                            Team members mood
                                        </a>
                                    </div>
                                    <div className="header-column p-0">
                                        <a href="/HrOffboardingGrid" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Offboarding.svg" className="me-3" alt="" />
                                            Offboarding
                                        </a>
                                        <a
                                            onClick={() => {
                                                navigate('/concerns', { state: { way: 'Team Member' } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Raise a Concern.svg" className="me-3" alt="" />
                                            Concern
                                        </a>
                                        <a href="/appreciation" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Appreciation.svg" className="me-3" alt="" />
                                            Appreciation
                                        </a>
                                        <a href={`/FeedbackGrid?EmpId=${empID}`} className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Feedback.svg" className="me-3" alt="" />
                                            Feedback
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="header-nav-item mx-3 dropdown">
                            <a
                                href=""
                                // className="header-nav-link dropdown-toggle semibold-text font-14 font-dark-blue pb-3"
                                className={
                                    linkview.includes('/HolidayList') || linkview.includes('/FAQ') || linkview.includes('/policy')
                                        ? ' header-nav-link active semibold-text font-14 font-dark-blue pb-3'
                                        : 'header-nav-link semibold-text font-14 font-dark-blue pb-3'
                                }
                                id="navbarDropdown"
                                role="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                How Do I?
                            </a>
                            <div className="header-dropdown-content p-0">
                                <div className="row">
                                    <div className="header-column p-0">
                                        <a
                                            onClick={() => {
                                                navigate(`/leaveform`, { state: { switchTab: 'leave', way: 'howDoI' } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Leave Request.svg" className="me-3" alt="" />
                                            Leave Request
                                        </a>
                                        <a
                                            href="/wfhform"
                                            onClick={() => {
                                                navigate(`/wfhform`, { state: { switchTab: 'wfh', way: 'howDoI' } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/WFH Request.svg" className="me-3" alt="" />
                                            WFH Request
                                        </a>
                                        <a
                                            onClick={() => {
                                                navigate('/concernForm', { state: { way: 'HowDoI' } });
                                            }}
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Raise a Concern.svg" className="me-3" alt="" />
                                            Raise a Concern
                                        </a>
                                        <a
                                            href="https://avacorp1.sharepoint.com/sites/AVAPortal?CID=436a98d3-f1b3-438c-ad2e-1ca28aa3a2c9&xsdata=MDV8MDF8fGVkMjJlNTliMWFlMDRhODc5YTY3MDhkYjIwOTFkOWI3fDcxNmY4M2MzN2FiZDQyYTE4NmQyZTAyMDdmNGFhOTgxfDB8MHw2MzgxMzk1ODI5OTgwOTIzOTF8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaVYybHVNeklpTENKQlRpSTZJazkwYUdWeUlpd2lWMVFpT2pFeGZRPT18MXxNVFkzT0RNMk1UUTVPRGc0TnpzeE5qYzRNell4TkRrNE9EZzNPekU1T2pRMk56RmpZbVpoTFRFMFkySXROREZsTWkwNVlUYzJMV0k0TkRBeFpqZzRaV0UzTkY4MFltSmpOelJoTWkweU56QTFMVFF3TW1FdFlXVTBNUzFqWkdGaU4yVXlaRGcwTVRSQWRXNXhMbWRpYkM1emNHRmpaWE09fGNkMjU4NTYwZDQzMjQwYjU5YTY3MDhkYjIwOTFkOWI3fDBlMjU2MjRjZmYwMzQ2ODJiMDRhYjQwZjFlMTM0MDYy&sdata=VjJTaGk0MnNwb2IzWDAzUUtpTDJYK1p1SjUvajhHUjBWYitnMWFNWHN4Zz0%3D&ovuser=716f83c3-7abd-42a1-86d2-e0207f4aa981%2CJayalakshmi.p%40avasoft.com&OR=Teams-HL&CT=1678362652106&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyNy8yMzAyMDUwMTQyMSIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D"
                                            target="_blank"
                                            className="ps-4 header-text-orange font-14 medium-text"
                                        >
                                            <img src="/Images/Employee-gallery-icon.svg" className="me-3" alt="" />
                                            Employee Gallery
                                        </a>
                                    </div>
                                    <div className="header-column p-0">
                                        <a href="/HolidayList" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/Holiday.svg" className="me-3" alt="" />
                                            Holiday List
                                        </a>
                                        <a href="/FAQ" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/FAQS.svg" className="me-3" alt="" />
                                            FAQ's
                                        </a>
                                        <a href="/policy" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/policy.svg" className="me-3" alt="" />
                                            Policy
                                        </a>
                                        {encryptStorage.getItem("grc") || encryptStorage.getItem("groupid") == 1 ? (<a href="/policyDirectory" className="ps-4 header-text-orange font-14 medium-text">
                                            <img src="/Images/policy.svg" className="me-3" alt="" />
                                            Policy Directory
                                        </a>) : <></>}
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li className="dropdown mx-3">
                            <button
                                onClick={() => {
                                    loaddata();
                                }}
                                className="btn p-0"
                                type="button"
                                id="notification"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                            >
                                <img
                                    src="/Images/bell-header.svg"
                                // className="pt-2"
                                />
                                <span
                                    id="notificationDot"
                                    className="position-absolute top-0 start-100 translate-middle p-1  border border-light "
                                ></span>
                            </button>
                            <div
                                className="dropdown-menu notifaction-dropdown header-column-notification header-nav-item header-dropdown-content"
                                style={{
                                    position: 'absolute',
                                    inset: '0px auto auto 0px',
                                    margin: '0px',
                                    transform: 'translate(-285px, 30px)',
                                }}
                                data-popper-placement="bottom-end"
                            >
                                <span className="position-absolute top-1 start-100 translate-middle p-1  border border-light "></span>
                                <NotificationTable notification={notificationData} />
                            </div>
                        </li>

                        <li className="header-nav-item mx-3 dropdown">
                            <a href="#" className="d-block link-dark text-decoration-none">
                                <img
                                    src="/Images/logo-person-user-person-icon.jpg"
                                    alt="header-profile"
                                    width={32}
                                    height={32}
                                    className="rounded-circle"
                                />
                            </a>
                            <div class="header-dropdown-content p-0">
                                <div class="d-flex">
                                    <div class="header-column-1 p-0 rounded-3">
                                        <a
                                            href={`/profilecontainer?EmpId=${empID}&IsTeamMember=true`}
                                            class="ps-4 header-text-orange font-12 bold-text"
                                        >
                                            <img src="/Images/Jobs Icon.svg" class="me-3" alt="" />
                                            My Profile
                                        </a>
                                        <a href="/" class="ps-4 header-text-orange font-12 bold-text" onClick={() => handleLogout()}>
                                            <img src="/Images/Onboarding.svg" class="me-3" alt="" />
                                            Logout
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </nav>
            );
        }
    };

    return (
        <div>
            {!hideNavBar ? (
                <div>
                    {/* NH_01 added hidden iframe for Enable cookie with sharepoint url  */}
                    {profile !== undefined ? (
                        <iframe src={profile} style={{ position: 'absolute', width: 0, height: 0, border: 0 }}></iframe>
                    ) : (
                        ''
                    )}
                    {HeaderHrManger()}
                    {HeaderEmployee()}
                    {HeaderManger()}
                    {/* {HeaderAdmin()} */}
                </div>
            ) : null}
        </div>
    );
}

export default NavHeader;
